import user from './user.svg';
import mail from './mail.svg';
import arrow from './arrow.svg';
import lock from './lock.svg';
import eye from './eye.svg';
import eyeCrossed from './eye-crossed.svg';

export const loginIcons = {
    user,
    mail,
    arrow,
    lock,
    eye,
    eyeCrossed
};